/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { status } from 'constants/general';

const initialState = {
  healthPlansList: {
    status: status.SHOULD_CALL_API,
    data: [],
    latestDataLength: null,
  },
  insurance: {
    status: status.SHOULD_CALL_API,
    data: [],
  },
  createHealthPlan: {
    status: status.SHOULD_CALL_API,
  },
  editHealthPlan: {
    status: status.SHOULD_CALL_API,
  },
  selectedHealthPlan: {
    status: status.SHOULD_CALL_API,
    data: {},
  },
};

const healthPlansSlice = createSlice({
  name: 'healthPlans',
  initialState,
  reducers: {
    fetchHealthPlans(state, action) {
      const { isShowMore } = action.payload;
      state.healthPlansList = {
        status: status.FETCHING,
        data: isShowMore ? state.healthPlansList.data : [],
        latestDataLength: state.healthPlansList.data?.length,
      };
    },
    fetchHealthPlansSuccess(state, action) {
      state.healthPlansList = {
        status: status.SUCCESS,
        data: [...state.healthPlansList.data, ...action.payload],
        latestDataLength: action.payload.length,
      };
    },
    fetchHealthPlansFail(state) {
      state.healthPlansList = {
        status: status.FAIL,
      };
    },
    fetchInsurance(state) {
      state.insurance = {
        status: status.FETCHING,
        data: [],
      };
    },
    fetchInsuranceSuccess(state, action) {
      state.insurance = {
        status: status.SUCCESS,
        data: action.payload,
      };
    },
    fetchInsuranceFail(state) {
      state.insurance = {
        status: status.FAIL,
      };
    },
    createHealthPlan(state) {
      state.createHealthPlan = {
        status: status.FETCHING,
      };
    },
    createHealthPlanSuccess(state) {
      state.createHealthPlan = {
        status: status.SUCCESS,
      };
    },
    createHealthPlanFail(state) {
      state.createHealthPlan = {
        status: status.FAIL,
      };
    },
    editHealthPlan(state) {
      state.editHealthPlan = {
        status: status.FETCHING,
      };
    },
    editHealthPlanSuccess(state) {
      state.editHealthPlan = {
        status: status.SUCCESS,
      };
    },
    editHealthPlanFail(state) {
      state.editHealthPlan = {
        status: status.FAIL,
      };
    },
    fetchSelectedealthPlan(state, action) {
      state.selectedHealthPlan = {
        status: status.FETCHING,
      };
    },
    fetchSelectedealthPlanSuccess(state, action) {
      state.selectedHealthPlan = {
        status: status.SUCCESS,
        data: action.payload,
      };
    },
    fetchSelectedealthPlanFail(state) {
      state.selectedHealthPlan = {
        status: status.FAIL,
      };
    },
    resetSelectedHealthPlan(state) {
      state.selectedHealthPlan = {
        status: status.SHOULD_CALL_API,
        data: {},
      };
    },
  },
});

export const selectedHealthPlanCountrySelector = state =>
  state?.common?.countries?.data?.[`${state?.healthPlans?.selectedHealthPlan?.data?.countryId}`];

export const {
  fetchHealthPlans,
  fetchHealthPlansSuccess,
  fetchHealthPlansFail,
  fetchInsurance,
  fetchInsuranceSuccess,
  fetchInsuranceFail,
  createHealthPlan,
  createHealthPlanSuccess,
  createHealthPlanFail,
  editHealthPlan,
  editHealthPlanSuccess,
  editHealthPlanFail,
  fetchSelectedealthPlan,
  fetchSelectedealthPlanSuccess,
  fetchSelectedealthPlanFail,
  resetSelectedHealthPlan,
} = healthPlansSlice.actions;

export default healthPlansSlice.reducer;
